import React from 'react';
import './Footer.scss';

export const Footer: React.FC = () => {
  return (
    <footer className="footer">
      Copyright &#169; 2020 XIE MIN
    </footer>
  )
}

